// src/components/ToastContainer/ToastContainer.jsx
import React from 'react';
import ToastNotification from '../ToastNotification/ToastNotification';
import './ToastContainer.css';

const ToastContainer = ({ toasts, onRemoveToast }) => {
  return (
    <div className="toast-container">
      {toasts.map((toast, index) => (
        <div 
          key={toast.id} 
          className="toast-wrapper"
          style={{ 
            '--index': index,
            bottom: `${20 + (index * 80)}px` 
          }}
        >
          <ToastNotification
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={() => onRemoveToast(toast.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;